export default {
    getInstitutions: state => state.institutions,
    getSchools: state => state.schools,
    getSchoolById: state => (idSchool) => state.schools.find(s => s.id == idSchool),
    getSchoolsInGop: state => state.schools.filter(school => school.gop_asociated && school.status === 1)
}
